import { prop } from 'ramda';
import { useEffect } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';

import * as server from './server';
import * as helpers from '../../helpers';
import * as actions from '../../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../../store';

export const useFetchComponent = ({ setError, translate }) => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const { showComponentMessage } = useComponentMethods();
    const getErrorMessage = useGetErrorMessage();
    const isLoading = useDynamicReducerSelector(prop('isLoading'));

    useEffect(() => {
        if (!isMounted() || !isLoading) {
            return;
        }

        setError('');

        (async () => {
            try {
                const config = await server.getRgConfiguration();
                const { enabled, minWithdrawAmount, minLimitValue } = config?.data?.autoWithdrawConfigurationItems?.[0] || {};

                if (!enabled) {
                    isMounted() && showComponentMessage(translate('notEnabled'));

                    return;
                }

                const limitsData = await server.getAutomaticWithdrawLimits();
                const limits = helpers.parseAutomaticWithdrawLimits(limitsData?.data);

                if (isMounted()) {
                    dispatch(actions.setLimits(limits));
                    dispatch(actions.setConfig({ enabled, minWithdrawAmount, minLimitValue }));
                }
            } catch (error) {
                const errorMsg = getErrorMessage(error);

                isMounted() && setError(errorMsg);
            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();
    }, [
        setError, dispatch, isMounted, translate,
        isLoading, showComponentMessage, getErrorMessage
    ]);
};
